import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import isBetween from 'dayjs/plugin/isBetween'
import 'dayjs/locale/th' // Ensure 'th' locale is imported

const DEFAULT_TIMEZONE = 'Asia/Bangkok'

export function globalConfigDayjs() {
  dayjs.extend(utc)
  dayjs.extend(timezone)
  dayjs.extend(isBetween)
  dayjs.tz.setDefault(DEFAULT_TIMEZONE)
}

/**
  * If date is undefined or null, dayjs.tz will use the current time in the specified/default timezone.
  */
export function createDayjsDate(date) {
  return date == null
    ? dayjs.tz(new Date(), DEFAULT_TIMEZONE)
    : dayjs.tz(date, DEFAULT_TIMEZONE)
}
